import {baseApiInstance} from "./baseApiInstance";

const postApiRequest = async (url, data = {}, config = {}) => {
    const response = await baseApiInstance
        .post(url, data, config)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return error;
        });

    return response;
};

export default postApiRequest;
